import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BookingFlowService } from '../service/booking-flow.service';
import { autoUnsubWith, Utility } from '@shared/services/utility.abstract';
import { ToastService } from '@shared/services/toast.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { PaymentSucessComponent } from '../payment-success/payment-success.component';
import { BOOKING_CREATED_SUCCESS_MSG } from '@shared/constant/shared.constant';

@Component({
  selector: 'app-payment-paid-modal',
  templateUrl: './payment-paid-modal.component.html',
  styleUrls: ['./payment-paid-modal.component.scss'],
})
export class PaymentPaidModalComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  bodyText: string;
  bookingPaymentMode: number;
  bookingId: any;
  assisstedListUrl: any;
  totalAmount: any;
  selectedUserId: any;
  bookingType: any;

  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig,
    private readonly bookingFlowService: BookingFlowService,
    private readonly toastService: ToastService,
    private readonly dialogControlService: DialogControlService,
  ) {}

  ngOnInit() {
    this.bodyText = this.config?.data?.bodyText;
    this.bookingPaymentMode = this.config?.data?.bookingPaymentMode;
    this.bookingId = this.config?.data?.bookingId;
    this.assisstedListUrl = this.config?.data?.assisstedListUrl;
    this.totalAmount = this.config?.data?.total;
    this.selectedUserId = this.config?.data?.selectedUserId;
    this.bookingType = this.config?.data?.bookingType;
  }

  closeDialog() {
    this.ref.close();
  }

  onconfirm() {
    let request = {
      bookingId: this.bookingId,
      timeZone: Utility.getLocalTimeZone(),
    };
    this.bookingFlowService.createBookingPaymentOffline(request)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response) => {
        this.ref.close();
        this.dialogControlService.openDialog(PaymentSucessComponent, {
              width: '20%',
              data: {
                assistedUrl: this.assisstedListUrl,
                bodyText: BOOKING_CREATED_SUCCESS_MSG,
                buttonText: 'OK',
                redirectUrl: response.data,
                selectedUserId: this.selectedUserId,
                bookingType :  this.bookingType
              },
            });
      },
      error: (error) => {
        this.toastService.showToastMessage(
          'error',
          'Error',
          error.error.message
        );
      },
    });
  }
}
